import { IconApp } from '@components/icons/app';
import { IconFiles } from '@components/icons/files';
import { IconPersonDetails } from '@components/icons/icon-person-details';
import { IconJourneyApp } from '@components/icons/journey-app';
import { IconMessages } from '@components/icons/messages';
import { IconNotes } from '@components/icons/notes';
import { IconRatingGood } from '@components/icons/rating-good';
import { IconTeam } from '@components/icons/team';
import { useIsMobile } from '@hooks/use-is-mobile';

import { useFeature } from 'features/authentication/authentication-queries';
import { useStore } from 'models/Provider';

export const useApplicationTabs = (application) => {
  const { t } = useStore();
  const isMobile = useIsMobile();
  const hasJourneysIntegration = useFeature('FEATURE_INTEGRATION_JOURNEYS');
  const useMessages = application.job.useMessages;
  const linkRoot = `/jobs/${application.job.id}/application/${application.id}/`;

  const items = [
    {
      display: t('application.tabs.details'),
      icon: isMobile ? undefined : <IconPersonDetails />,
      value: 'details',
      link: linkRoot + 'details',
    },
    {
      display: t('application.tabs.notes'),
      icon: isMobile ? undefined : <IconNotes />,
      value: 'notes',
      count: application.numNotes,
      activeCount: application.userRead && !application.userRead.notes,
      link: linkRoot + 'notes',
    },
    {
      display: t('application.tabs.ratings'),
      icon: isMobile ? undefined : <IconRatingGood />,
      value: 'ratings',
      count: application.numReviews,
      activeCount: application.userRead && !application.userRead.ratings,
      link: linkRoot + 'ratings',
    },
    {
      display: t('application.tabs.files'),
      icon: isMobile ? undefined : <IconFiles />,
      value: 'files',
      count: application.numAttachments,
      activeCount: application.userRead && !application.userRead.files,
      link: linkRoot + 'files',
    },
    ...(hasJourneysIntegration
      ? [
          {
            display: t('application.tabs.journeys'),
            icon: isMobile ? undefined : <IconJourneyApp />,
            value: 'journeys',
            link: linkRoot + 'journeys',
          },
        ]
      : []),
    {
      display: t('application.tabs.apps'),
      icon: isMobile ? undefined : <IconApp />,
      value: 'apps',
      link: linkRoot + 'apps',
    },
    {
      display: t('application.tabs.access'),
      icon: isMobile ? undefined : <IconTeam />,
      value: 'access',
      link: linkRoot + 'access',
    },
  ];

  if (useMessages) {
    items.splice(4, 0, {
      display: t('application.tabs.messages'),
      icon: isMobile ? undefined : <IconMessages />,
      count: application.numMessages,
      value: 'messages',
      activeCount: application.userRead && !application.userRead.messages,
      error: application.userRead?.messagesFailed === false,
      link: linkRoot + 'messages',
    });
  }
  return items;
};
